var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,6H7.5c-1.379,0-2.5,1.122-2.5,2.5l.007,8.506h14l-.007-8.507c0-1.378-1.122-2.5-2.5-2.5Zm0,1c.361,0,.693,.128,.952,.341l-4.102,4.102c-.717,.717-1.966,.717-2.683,0L6.558,7.334c.258-.209,.586-.334,.942-.334h9ZM6.007,16.007l-.007-7.507c0-.097,.01-.191,.027-.283l3.933,3.933c.548,.547,1.275,.849,2.049,.849s1.501-.301,2.048-.849l3.919-3.919c.016,.087,.025,.177,.025,.268l.007,7.507H6.007ZM12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm0,23c-6.065,0-11-4.935-11-11S5.935,1,12,1s11,4.935,11,11-4.935,11-11,11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleEnvelope);
export default __webpack_public_path__ + "static/media/circle-envelope.9ec3f67acaee155f656b53b8910702f3.svg";
export { ForwardRef as ReactComponent };